module.exports = __webpack_public_path__ + "static/media/ic_gaz.e3a3662a.png";